export const getDataTablePageCount = (
  pageCount?: number | undefined,
  totalCount?: number | undefined,
  limit?: number | undefined
): number => (typeof pageCount === 'number' ? pageCount : Math.ceil((totalCount || 0) / (limit ?? DATA_TABLE_LIMIT)));

export const DATA_TABLE_LIMIT = 30;
